import React, { useEffect, useRef, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";
import gsap from "gsap";


const BUTTON_NEXT_ID = "buttonNextRandom";
let checkInitAnimation = false

export const RandomQuestion = ({ numberQuestion = -1, arrayQuestion = [{ id: -1 }], anserwerQuestion = [{ id: -1 }], action = () => { }, textStyleContainerQuestion = "" }) => {
	const [selectAnswer, setSelectAnswer] = useState(-1);
	const [isNextQuestion, setIsNextQuestion] = useState(false)
	const animationRef = useRef(null);

	const actionButtonNext = () => {
		if (selectAnswer === -1) {
			return
		}

		if (isNextQuestion) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
			action(selectAnswer);
			setSelectAnswer(-1);
			checkInitAnimation = false
		}

		setIsNextQuestion(!isNextQuestion)
	}

	useEffect(() => {
		if (selectAnswer === -1) {
			stopAnimation();
			return
		}
		if (checkInitAnimation) {
			return
		}
		checkInitAnimation = true
		gsapAnimation()
	}, [selectAnswer])


	const gsapAnimation = () => {
		animationRef.current = gsap.to(`#${BUTTON_NEXT_ID}`, {
			duration: 0.5,
			scale: 0.8,
			backgroundColor: "#FFC427",
			repeat: -1,
			yoyo: true,
		});
	};

	const stopAnimation = () => {
		gsap.set(`#${BUTTON_NEXT_ID}`, {
			scale: 1,
			backgroundColor: "#9A9A9A",
		});
		if (animationRef.current) {
			animationRef.current.kill();
			animationRef.current = null;

		}
	};

	return (
		<>
			<div className="fixed z-30 bottom-0 h-full w-full flex justify-center items-center overflow-hidden">
				<div className="h-[248px] w-[664px] md:h-[336px] md:w-[704px] overflow-hidden rounded-[32px] border-[2px] border-white">
					<div className="bg-red_primary h-[112px] md:h-[144px] w-[100%] p-4 flex">
						<div className="h-full w-[590px] bg-[#ffffff] rounded-2xl flex items-center px-8">
							<p className={`text-black text-[12px] md:text-[16px] ${textStyleContainerQuestion}`}>{arrayQuestion[numberQuestion]?.text ?? ""}</p>
						</div>
						<div className="h-full w-[calc(100%-590px)] flex justify-end">
							<p className="text-white text-[14px] font-semibold">
								{numberQuestion + 1}/{arrayQuestion.length}
							</p>
						</div>
					</div>
					<div className="gradiantBlueClient h-[calc(100%-112px)] md:h-[calc(100%-144px)] pt-2 px-4 pb-4">
						<div className="flex justify-center items-center h-[24px]">
							<p className="text-white text-[14px]">Seleciona tu respuesta</p>
						</div>
						<div className="h-[calc(100%-24px)] md:h-full flex">
							<div className="h-full w-[calc(100%-148px)] md:w-full flex justify-center items-center gap-2 md:gap-6">
								{anserwerQuestion.map((anserw, index) => {
									let backColorFeedBack = "bg-[#ffffff66]"
									if (isNextQuestion) {
										// rojo a la que selecionas
										if (selectAnswer === anserw.id) {
											backColorFeedBack = "bg-[#DF3C3C]"
										}
										// muestra cual es la correcta
										if (arrayQuestion[numberQuestion].id === anserw.id) {
											backColorFeedBack = "bg-[#22C55E]"
										}
									} else {
										if (anserw.id === selectAnswer) {
											backColorFeedBack = "bg-yellow_primary"
										}
									}
									// arrayQuestion[numberQuestion].id === selectAnswer
									return (
										<div
											onClick={() => {
												ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoInformacion)
												if (!isNextQuestion) {
													setSelectAnswer(anserw.id);
												}
											}}
											key={`${index}-answer-game`}
											className={`h-[80px] w-[80px] md:h-[112px] md:w-[112px] ${backColorFeedBack}  rounded-3xl p-[6px]`}
										>
											<div className="h-full w-full border-[2px] border-white rounded-3xl overflow-hidden">
												<div className="h-[75%] w-full">
													<div className="h-full w-full">
														<img className="h-full w-full object-contain" src={anserw.img} alt="cliente" />
													</div>
												</div>
												<div className="h-[25%] w-full bg-white flex justify-center items-center">
													<p className="text-black text-[9px] md:text-[12px] font-semibold">{anserw.title}</p>
												</div>
											</div>
										</div>
									);
								})}
							</div>
							<div className="h-full w-[148px] flex items-end md:hidden md:w-[0px]">
								<div
									id="buttonNextRandom"
									onClick={() => {
										actionButtonNext()
									}}
									className="w-full h-[30px] bg-yellow_primary flex justify-center items-center rounded-2xl"
								>
									<p className="text-white text-[16px] font-semibold">{isNextQuestion ? "Siguiente" : "Responder"}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					id="buttonNextRandom"
					onClick={() => {
						actionButtonNext()
					}}
					className="hidden fixed md:flex justify-center items-center h-[32px] w-[200px] bg-gray_text_block z-30 bottom-8 right-10 rounded-2xl"
				>
					<p className="text-white text-[18px] font-semibold">{isNextQuestion ? "Siguiente" : "Responder"}</p>
				</div>
			</div>
		</>
	);
};
